import type { Relationship } from "../common/types";
import type { RelationshipInfoProps } from "./RelationshipInfo";

export const getRelationshipInfo = (
  relationship: Relationship,
): RelationshipInfoProps => {
  switch (relationship.type) {
    case "ACH":
      return {
        type: "ACH",
        logo: relationship.logo,
        bankName: relationship.brand_name,
        accountName: relationship.account_name ?? "",
        status:
          relationship.status === "REJECTED"
            ? {
                text: "Action Required",
                variant: "rose",
              }
            : undefined,
      };
    case "Wire":
      return {
        type: "Wire",
        bankName: relationship.name,
        accountName: "Wire",
        status:
          relationship.status === "REJECTED"
            ? {
                text: "Action Required",
                variant: "rose",
              }
            : undefined,
      };
    case "CurrencyCloud":
      return {
        type: "CurrencyCloud",
        bankName: relationship.bank_name,
        accountName: "CurrencyCloud",
      };
    default:
      return {
        type: "Wire",
        bankName: "",
        accountName: "",
      };
  }
};
